import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import cLanguageImage from '../../images/cardpageimages/technicalcourse/clanguage.png';
import IntroVideos from "../../componants/introvideos";
import CLanguageModule from "../../componants/allCourseModule/TechnicalCourseModule/CLanguageModule";

function CLanguage() {
  return (
    <>
      <Header />
      <BannerForAll
        title="C LANGUAGE FULL COURSE"
        text="Our C Language Full Course is crafted to provide an in-depth understanding of programming basics. It covers syntax, data types, functions, pointers, and more, enabling beginners to develop a strong foundation in programming and logical thinking. Ideal for those entering the world of coding, this course sets you up for further learning in various programming languages."
        imageone={cLanguageImage}
        imagetwo={cLanguageImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="C LANGUAGE"
      />
      <CLanguageModule />
      <Footer />
    </>
  );
}

export default CLanguage;
